import { Box, Button } from '@mui/material'
import React from 'react'
import sizeFontCustom from "../Discovery/fontSize.styles"
import { useTranslation } from '../../hooks/useTranslation'

function CancelConsent({handleCancel, handleDeny, customDetails}) {
  const { t } = useTranslation();
  let isDarkTheme = customDetails?.darkTheme === true;
  return (
        <Box sx={{ display: { xs: "flex" }, marginTop:"1rem" }}>
          <Button
            variant='text' 
            color='error' 
            onClick={handleDeny}
            sx={{
              width: "80%",
              height: "2rem",
              textTransform: "none",
              fontWeight: 600,
              marginRight:"1rem",
              ...sizeFontCustom.heading,
              backgroundColor: isDarkTheme ? 'transparent !important' : '#ffffff !important',
              color: '#E94B4B !important',
              borderColor: '#E94B4B !important',
              '&:hover': {
                backgroundColor: 'rgba(233, 75, 75, 0.04) !important',
                borderColor: '#E94B4B !important',
              },

            }}
          >
            {t('common.buttons.yesExit')}
          </Button>
          <Button
            variant="contained"
            onClick={handleCancel}
            sx={{
              width: "80%",
              height: "2rem",
              textTransform: "none",
              fontWeight: 600,
              ...sizeFontCustom.heading,
              backgroundColor: customDetails?.primaryColor || undefined,
              color: customDetails?.ctaTextColor ?? '#fff',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: customDetails?.primaryColor
                  ? `color-mix(in srgb, ${customDetails.primaryColor} 85%, black 15%)`
                  : undefined,
                boxShadow: 'none',
              },
            }}
          >
            {t('common.buttons.goBack')}
          </Button>
          
    </Box>  )
}

export default CancelConsent